import { createFileRoute } from '@tanstack/react-router';
import { ClientDashboardPage } from '../firm/client-dashboard-page';
import { FeatureGate } from '../firm/feature-gate';

export const Route = createFileRoute('/clients/$caseId/')({ component: ClientOverview });

/** One client's overview (ADR-037), with CHECK-POINT. */
function ClientOverview() {
  const { caseId } = Route.useParams();
  return (
    <FeatureGate feature="check-point">
      <ClientDashboardPage caseId={caseId} />
    </FeatureGate>
  );
}
